import { render, staticRenderFns } from "./VehicleTypeTable.vue?vue&type=template&id=c34e03b0"
import script from "./VehicleTypeTable.vue?vue&type=script&lang=ts"
export * from "./VehicleTypeTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports